// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vertical-container_wrapper__dhW39","main":"vertical-container_main__2B7O4","scrollable":"vertical-container_scrollable__3Em7V"};